import { z } from "zod";

import { NameDescriptionItemSchema } from "./NameDescriptionItem.schema";

/**
 * Summarisation config — stored under `{ summarisation: { ... } }`.
 * _v: 1
 */
export const SummarisationPromptConfigSchema = z.object({
  _v: z.literal(1).default(1),
  length: z.string(),
  toneStyle: z.string().optional(),
  focusElements: z.array(NameDescriptionItemSchema).optional(),
  detailLevel: z.string(),
  paraphrasingLevel: z.string(),
  quoteInclusion: z.string(),
  format: z.string(),
  header: z.string().optional()
});

export type SummarisationPromptConfig = z.infer<typeof SummarisationPromptConfigSchema>;
